<template>
	<div>
		<div class="hidden-xs-only">
			<div class="">
				<img :src="info.bg_url" class="width-100 h-500">
				<div class="fu h-500 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-57 c-white d-flex-center">联系我们</div>
						<div class="f-28 c-white d-flex-center m-t-10">CONTACT US</div>
					</div>
				</div>
			</div>
			<div class="bgc-white d-flex-center">
				<div class="w-80p">
					<div class="m-t-45">
						<div class="f-30 c-00">联系我们</div>
						<div class="f-24 c-99 m-t-25">CONTACT US</div>
					</div>
					<div class="m-t-45 d-flex-between p-b-130">
						<div @click="choice(index)" v-for="(item,index) in way" :key="index">
							<div class="d-flex-row h-40 lh-40">
								<div class="w-10 h-40 bgc-f27467"></div>
								<div class="f-24 c-00 m-l-5">{{item.name}}</div>
							</div>
							<div v-if="index==0" class="m-t-20 f-18 c-66">{{info.tel}}</div>
							<div v-if="index==1" class="m-t-20 f-18 c-66">{{info.email}}</div>
							<div v-if="index==2" class="m-t-20 f-18 c-66">{{info.wx}}</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bgc-f7f6fb d-flex-center">
				<div class="w-80p">
					<div class="h-115 lh-115 f-30 c-00 d-flex-center">
						所在地区:{{info.address}}
					</div>
					<div>
						<el-amap
			v-if="clientWidth>767"
                  ref="map"
                  :vid="'amapDemo'"
                  :center="center"
                  :zoom="zoom"
                  class="bm-view"
                 >
                 <el-amap-marker :position="center">
                 </el-amap-marker>
              </el-amap>
					</div>
				</div>
			</div>
		</div>


		<div class="hidden-sm-and-up">
			<div class="">
				<img :src="info.bg_url" class="width-100 h-300">
				<div class="fu1 h-300 d-flex-items-center d-flex-center">
					<div class="m-t-20">
						<div class="f-30 c-white d-flex-center">联系我们</div>
						<div class="f-20 c-white d-flex-center m-t-10">CONTACT US</div>
					</div>
				</div>
			</div>

			<div class="bgc-white m-t-10">
				<div class="p-t-10">
					<div class="f-20 c-00 d-flex-center">联系我们</div>
					<div class="f-14 c-99 m-t-10 d-flex-center">CONTACT US</div>
				</div>
				<div class="d-flex-center">
					<div class="m-t-20 width-80">
						<div v-for="(item,index) in way" :key="index" class="d-flex-row lh-20 m-b-15">
							<div class="w-10 h-20 bgc-ec5e52 m-r-10"></div>
							<div class="f-15 c-00 m-r-30">{{item.name}}</div>
							<div v-if="index==0" class="f-12 c-33">{{info.tel}}</div>
							<div v-if="index==1" class="f-12 c-33">{{info.email}}</div>
							<div v-if="index==2" class="f-12 c-33">{{info.wx}}</div>
						</div>
						<div class="d-flex-row lh-20 m-b-15">
							<div class="w-10 h-20 bgc-ec5e52 m-r-10"></div>
							<div class="f-15 c-00 m-r-30">所在地区:</div>
							<div class="f-12 c-33">{{info.address}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="bgc-f7f6fb d-flex-center">
				<div class="w-90p p-t-20 p-b-20">
					<el-amap
				v-if="clientWidth<767"
                  ref="map"
                  :vid="'amapDemo'"
                  :center="center"
                  :zoom="zoom"
                  class="bm-view1"
                 >
                 <el-amap-marker :position="center">
                 </el-amap-marker>
              </el-amap>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Loading
	} from 'element-ui';
	export default {
		data() {
			return {
				way: [{
						name: "咨询热线:",
						text: "0431-81802555"
					},
					{
						name: "QQ邮箱:",
						text: "2014261541qq.com"
					},
					{
						name: "微信公众号:",
						text: "长春市人才公寓"
					}
				],
				center: [
					116.404,
					39.915
				],
				zoom: 13,
				info: {},
				clientWidth:document.documentElement.clientWidth
			}
		},
		mounted() {
			window.onresize = ()=> {
				this.clientWidth = document.documentElement.clientWidth
			};
			this.getinfo()
		},
		methods: {
			async getinfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				const res = await this.$service.get({
					url: '/api/web/v1/app_get_contact'
				})
				if (res.code === 1) {
					this.info = res.info;
					this.center = [res.info.address_location.lng,res.info.address_location.lat];
					this.$nextTick(() => {
						loading.close();
					}, 2000);
				}
			},
		}
	}
</script>

<style scoped>
	.fu {
		position: relative;
		margin-top: -500px;
	}

	.fu1 {
		position: relative;
		margin-top: -300px;
	}

	.bm-view {
		width: 100%;
		height: 454px;
	}

	.bm-view1 {
		width: 100%;
		height: 280px;
	}
</style>
